import React, { useEffect, useState } from "react";
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { Box, Typography, Checkbox, FormControlLabel, CircularProgress, Chip } from '@mui/material';
import Apiconnection from "../../utils/Apiconnection";
import { toast } from "react-toastify";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import PolicyModal from "../../component/PolicyModal";

const TERMS_VERSION = "v2026.1";

const PaymentForm = ({ payload = {}, clientsecret, stripeorderid, totalAmount, onCancel }) => {
    const stripe = useStripe();
    const elements = useElements();
    
    console.log('PaymentForm - payload:', payload);
    console.log('PaymentForm - stripe status:', !!stripe);
    console.log('PaymentForm - elements status:', !!elements);
    console.log('PaymentForm - clientsecret:', clientsecret);

    const userId = JSON.parse(localStorage.getItem('userInfo'));

    const { email, customerId, firstName, lastName, phone, licensePlateNumber } = payload;
    console.log('Payment-form_customerId', customerId);

    const [vendorId] = useState(payload?.vendorId);
    const [vechiletypeId] = useState(payload?.vehicleTypeId);
    const [slotId] = useState(payload?.slotId);
    const [dialCode] = useState(payload?.dialCode);
    const [fromDate] = useState(payload?.fromDate);
    const [toDate] = useState(payload?.toDate);

    const [startDateTime] = useState(payload?.fromDate + 'T' + payload?.selectedCheckInTime);
    const [endDateTime] = useState(payload?.toDate + 'T' + payload?.selectedCheckOutTime);
    const [errorMessage, setErrorMessage] = useState(null);

    const [email2] = useState(payload?.email);
    const [fname] = useState(payload?.firstName || payload?.firstname);
    const [lname] = useState(payload?.lastName || payload?.lastname);
    const [mob] = useState(payload?.phone);
    const [custId] = useState(payload?.customerId);
    
    const [isProcessing, setIsProcessing] = useState(false);
    const [isPaymentReady, setIsPaymentReady] = useState(false);
    const [mobileNumber2] = useState(payload?.password);

    // Strict duplicate payment prevention & safe booking recovery states
    const [isPaymentCaptured, setIsPaymentCaptured] = useState(false);
    const [capturedPaymentRef, setCapturedPaymentRef] = useState(null);
    const [bookingFailedAfterPayment, setBookingFailedAfterPayment] = useState(false);
    const [bookingErrorMessage, setBookingErrorMessage] = useState(null);
    const [isRetryingBooking, setIsRetryingBooking] = useState(false);
    const [verifiedTransactionData, setVerifiedTransactionData] = useState(null);

    // Mandatory No-Refund clickwrap & legal metadata states
    const [noRefundAccepted, setNoRefundAccepted] = useState(false);
    const [consentTimestamp, setConsentTimestamp] = useState(null);
    const [policyModalOpen, setPolicyModalOpen] = useState(false);
    const [policyModalTab, setPolicyModalTab] = useState('terms');

    const navigate = useNavigate();

    const handleCheckboxToggle = (e) => {
        const checked = e.target.checked;
        setNoRefundAccepted(checked);
        if (checked) {
            setConsentTimestamp(new Date().toISOString());
        } else {
            setConsentTimestamp(null);
        }
    };

    const openPolicy = (tab) => {
        setPolicyModalTab(tab);
        setPolicyModalOpen(true);
    };

    useEffect(() => {
        if (!stripe) {
            return;
        }

        const clientSecretParam = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
        );

        if (!clientSecretParam) {
            return;
        }

        console.log('payment_intent_client_secret from 3DS redirect URL:', clientSecretParam);

        stripe.retrievePaymentIntent(clientSecretParam).then(({ paymentIntent }) => {
            switch (paymentIntent.status) {
                case "succeeded":
                    console.log("payment success");
                    break;
                case "processing":
                    console.log("Your payment is processing");
                    break;
                case "requires_payment_method":
                    console.log("Your payment was not successfully, please try again");
                    break;
                default:
                    console.log("something went wrong");
                    break;
            }
        });
    }, [stripe, clientsecret]);

    const processBookingFulfillment = async ({
        currentConsentTimestamp,
        customerFirstName,
        customerLastName,
        fullName,
        customerEmail,
        customerPhone,
        customerIdentifier
    }) => {
        setIsProcessing(true);
        setIsRetryingBooking(true);
        setBookingFailedAfterPayment(false);
        setBookingErrorMessage(null);

        try {
            let txId = verifiedTransactionData?.id;
            let txCreatedId = verifiedTransactionData?.transactionCreatedId;

            if (!txId || !txCreatedId) {
                const verifyPaymentPayload = {
                    stripeOrderId: stripeorderid,
                    amount: totalAmount,
                    currency: "USD",
                    userId: userId?.id,
                    firstName: customerFirstName,
                    lastName: customerLastName,
                    name: fullName,
                    customer: customerIdentifier,
                    customerName: fullName,
                    email: customerEmail,
                    phone: customerPhone,
                    legal_consent_timestamp: currentConsentTimestamp,
                    terms_version_accepted: TERMS_VERSION,
                    cancellation_policy: "strict_no_refund",
                    no_refund_accepted: true,
                };

                const verifyPaymentResponse = await Apiconnection.post('verify-payment-via-stripe', verifyPaymentPayload);
                txId = verifyPaymentResponse?.data?.data?.id;
                txCreatedId = verifyPaymentResponse?.data?.data?.transactionCreatedId;
                setVerifiedTransactionData({ id: txId, transactionCreatedId: txCreatedId });
            }

            const activeSlotId = payload?.slotId || slotId;
            const activeFromDate = payload?.fromDate || fromDate;
            const activeToDate = payload?.toDate || toDate;
            const activePlateNumber = payload?.licensePlateNumber || licensePlateNumber;
            const activeCheckInTime = payload?.selectedCheckInTime || (startDateTime ? moment(startDateTime).format('HH:mm:ss') : '12:00:00');
            const activeCheckOutTime = payload?.selectedCheckOutTime || (endDateTime ? moment(endDateTime).format('HH:mm:ss') : '12:00:00');

            if (!activeSlotId) {
                throw new Error("Missing parking slot assignment. Please retry slot confirmation or contact support.");
            }

            let bookingPayload = {
                parkingGroundId: "1",
                bookingPlatform: "customerPanel",
                logInType: (customerId || custId) ? "Customer" : "Guest",
                customerId: customerId ? customerId : custId,
                vehicleTypeId: "72",
                dialCode: dialCode || payload?.dialCode || "+1",
                slotId: activeSlotId,
                firstName: customerFirstName,
                lastName: customerLastName,
                name: fullName,
                customer: customerIdentifier,
                customerName: fullName,
                email: customerEmail,
                phone: customerPhone,
                plateNumber: activePlateNumber,
                fromDate: moment(activeFromDate).format('YYYY-MM-DD'),
                selectedCheckInTime: activeCheckInTime,
                toDate: moment(activeToDate).format('YYYY-MM-DD'),
                selectedCheckOutTime: activeCheckOutTime,
                passengerCount: "4",
                transactionHistoryId: txId,
                transactionCreatedId: txCreatedId,
                legalConsentTimestamp: currentConsentTimestamp,
                termsVersionAccepted: TERMS_VERSION,
                cancellationPolicy: "strict_no_refund"
            };

            const response = await Apiconnection.post('booking-request-create', bookingPayload);
            if (response?.data?.status) {
                const bookingRequestId = response.data.data.id;
                const bookingRequestcheckinDate = response.data.data.fromDate;
                const bookingRequeststartTime = response.data.data.selectedCheckInTime;
                const bookingRequestcheckoutDate = response.data.data.toDate;
                const bookingRequestendTime = response.data.data.selectedCheckOutTime;

                const calculateBookingChargesPayload = {
                    onSiteChargeForVendor: "0",
                    parkingGroundId: "1",
                    platform: "CustomerPanel",
                    bookingRequestId,
                    vehicleTypeId: "72",
                    passengerCount: "4",
                    checkinDate: bookingRequestcheckinDate,
                    startTime: bookingRequeststartTime,
                    checkoutDate: bookingRequestcheckoutDate,
                    endTime: bookingRequestendTime,
                };

                const calculateBookingChargesResponse = await Apiconnection.post('calculate-booking-charges-before-booking', calculateBookingChargesPayload);
                if (calculateBookingChargesResponse?.data?.status) {
                    toast.success('Booked Successfully!');
                    const bookingDetails = {
                        invoiceCreate: calculateBookingChargesResponse.data.data?.invoiceCreate,
                        bookingRequestDetail: calculateBookingChargesResponse?.data?.data?.bookingRequestDetail,
                        customerid: bookingPayload?.customerId,
                        plateNumber: activePlateNumber,
                        licensePlateNumber: activePlateNumber,
                    };
                    navigate('/booking-details', { state: bookingDetails });
                    return;
                } else {
                    throw new Error('Failed to calculate booking charges.');
                }
            } else {
                const serverMsg = response?.data?.message || 'Server rejected booking reservation request.';
                throw new Error(serverMsg);
            }
        } catch (error) {
            console.error('Error fulfilling booking:', error);
            const errMsg = error?.response?.data?.message || error?.message || 'Could not finalize booking reservation.';
            setBookingFailedAfterPayment(true);
            setBookingErrorMessage(errMsg);
            toast.error(
                `Payment of $${totalAmount || '25'} received, but slot confirmation pending: ${errMsg}. DO NOT PAY AGAIN.`,
                { autoClose: 9000 }
            );
        } finally {
            setIsProcessing(false);
            setIsRetryingBooking(false);
        }
    };

    const handleRetryBookingOnly = async () => {
        const customerFirstName = String((customerId ? firstName : fname) || payload?.firstName || payload?.firstname || "").trim();
        const customerLastName = String((customerId ? lastName : lname) || payload?.lastName || payload?.lastname || "").trim();
        const fullName = `${customerFirstName} ${customerLastName}`.trim();
        const customerEmail = String((customerId ? email : email2) || payload?.email || "").trim();
        const rawCustomerPhone = (customerId ? phone : (custId ? mobileNumber2 : phone)) || payload?.phone;
        const customerPhone = rawCustomerPhone != null && String(rawCustomerPhone).trim() !== "" ? String(rawCustomerPhone).trim() : "";
        const customerIdentifier = customerId ? String(customerId) : (fullName || customerEmail);

        await processBookingFulfillment({
            currentConsentTimestamp: consentTimestamp || new Date().toISOString(),
            customerFirstName,
            customerLastName,
            fullName,
            customerEmail,
            customerPhone,
            customerIdentifier
        });
    };

    const handleSafeCancel = () => {
        if (isPaymentCaptured) {
            const shouldClose = window.confirm(
                `Payment of $${totalAmount || '25'}.00 was already charged (Ref: ${capturedPaymentRef || stripeorderid}). Closing now leaves your slot confirmation pending with our team. Do you still wish to close?`
            );
            if (!shouldClose) {
                return;
            }
        }
        if (onCancel) {
            onCancel();
        }
    };

    const handleSubmit = async (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        // Safeguard: If card was already charged, NEVER call Stripe confirmPayment again!
        if (isPaymentCaptured) {
            await handleRetryBookingOnly();
            return;
        }

        if (!noRefundAccepted) {
            toast.error('Please accept the Strict No-Refund Policy and Terms before paying.');
            return;
        }

        if (!stripe || !elements) {
            toast.error('Stripe.js has not loaded yet.');
            return;
        }

        setIsProcessing(true);
        setErrorMessage(null);
        setBookingFailedAfterPayment(false);
        setBookingErrorMessage(null);

        const currentUrl = new URL(window.location.href);
        const baseUrl = currentUrl.origin + currentUrl.pathname;
        const currentConsentTimestamp = consentTimestamp || new Date().toISOString();

        const customerFirstName = String((customerId ? firstName : fname) || payload?.firstName || payload?.firstname || "").trim();
        const customerLastName = String((customerId ? lastName : lname) || payload?.lastName || payload?.lastname || "").trim();
        const fullName = `${customerFirstName} ${customerLastName}`.trim();
        const customerEmail = String((customerId ? email : email2) || payload?.email || "").trim();
        const rawCustomerPhone = (customerId ? phone : (custId ? mobileNumber2 : phone)) || payload?.phone;
        const customerPhone = rawCustomerPhone != null && String(rawCustomerPhone).trim() !== "" ? String(rawCustomerPhone).trim() : "";
        const customerIdentifier = customerId ? String(customerId) : (fullName || customerEmail);

        const confirmBillingDetails = {};
        if (fullName) {
            confirmBillingDetails.name = fullName;
        }
        if (customerEmail) {
            confirmBillingDetails.email = customerEmail;
        }
        if (customerPhone) {
            confirmBillingDetails.phone = customerPhone;
        }

        // Confirm the payment with Stripe
        const result = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `${baseUrl}?#/booking-details`,
                payment_method_data: {
                    billing_details: confirmBillingDetails,
                },
            },
            redirect: "if_required",
        });

        console.log('Payment confirmation result:', result);

        if (result?.error) {
            console.error(result.error);
            toast.error(result.error.message || 'Payment failed.');
            setErrorMessage(result.error.message);
            setIsProcessing(false);
            return; // Payment was NOT charged. Customer can fix card and retry.
        }

        // --- PAYMENT CAPTURED IN STRIPE ---
        // Lock payment state so Stripe can NEVER be charged again!
        setIsPaymentCaptured(true);
        const paymentRef = result?.paymentIntent?.id || stripeorderid || "Confirmed";
        setCapturedPaymentRef(paymentRef);

        await processBookingFulfillment({
            currentConsentTimestamp,
            customerFirstName,
            customerLastName,
            fullName,
            customerEmail,
            customerPhone,
            customerIdentifier
        });
    };

    const currentCustomerFirstName = String((customerId ? firstName : fname) || payload?.firstName || payload?.firstname || "").trim();
    const currentCustomerLastName = String((customerId ? lastName : lname) || payload?.lastName || payload?.lastname || "").trim();
    const currentFullName = `${currentCustomerFirstName} ${currentCustomerLastName}`.trim();
    const currentEmail = String((customerId ? email : email2) || payload?.email || "").trim();
    const rawPhone = (customerId ? phone : (custId ? mobileNumber2 : phone)) || payload?.phone;
    const currentPhone = rawPhone != null && String(rawPhone).trim() !== "" ? String(rawPhone).trim() : "";

    const defaultBillingDetails = {};
    if (currentFullName) {
        defaultBillingDetails.name = currentFullName;
    }
    if (currentEmail) {
        defaultBillingDetails.email = currentEmail;
    }
    if (currentPhone) {
        defaultBillingDetails.phone = currentPhone;
    }

    const isPayDisabled = isProcessing || !stripe || !isPaymentReady || !noRefundAccepted;

    return (
        <>
            <form 
                onSubmit={handleSubmit} 
                style={{ 
                    minHeight: '200px', 
                    height: '100%', 
                    display: 'flex', 
                    flexDirection: 'column',
                    fontFamily: "'Inter', 'Poppins', sans-serif"
                }}
            >
                <Box
                    data-testid="payment-form-scroll-region"
                    sx={{ 
                        flex: 1, 
                        minHeight: 0, 
                        overflowY: 'auto', 
                        pr: { xs: 0.5, sm: 1 },
                        '&::-webkit-scrollbar': { width: '6px' },
                        '&::-webkit-scrollbar-track': { background: '#f8fafc' },
                        '&::-webkit-scrollbar-thumb': { background: '#cbd5e1', borderRadius: '4px' }
                    }}
                >
                    {isPaymentCaptured ? (
                        <Box sx={{ py: 1 }}>
                            {/* Payment Succeeded Confirmation Banner */}
                            <Box
                                sx={{
                                    backgroundColor: '#f0fdf4',
                                    border: '1.5px solid #86efac',
                                    borderRadius: '16px',
                                    p: 2.5,
                                    mb: 2.5,
                                    display: 'flex',
                                    gap: 1.5,
                                    alignItems: 'flex-start',
                                    textAlign: 'left'
                                }}
                            >
                                <CheckCircleRoundedIcon sx={{ color: '#16a34a', fontSize: '28px', mt: 0.2, flexShrink: 0 }} />
                                <Box sx={{ flex: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 0.5 }}>
                                        <Typography sx={{ fontWeight: 800, fontSize: '15px', color: '#15803d' }}>
                                            Payment of ${totalAmount ?? '25'}.00 Received Successfully
                                        </Typography>
                                        <Chip 
                                            label="Card Charged" 
                                            size="small" 
                                            sx={{ backgroundColor: '#dcfce7', color: '#166534', fontWeight: 800, fontSize: '11px', height: '20px' }} 
                                        />
                                    </Box>
                                    <Typography sx={{ fontSize: '13px', color: '#166534', lineHeight: 1.5 }}>
                                        Stripe Reference: <strong>{capturedPaymentRef || stripeorderid || 'Confirmed'}</strong>
                                        <br />
                                        Your payment has been captured once. <strong>Your card will NOT be charged again.</strong>
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Slot Reservation Status Notice */}
                            <Box
                                sx={{
                                    backgroundColor: '#fffbeb',
                                    border: '1.5px solid #fde68a',
                                    borderRadius: '16px',
                                    p: 2.5,
                                    mb: 2.5,
                                    display: 'flex',
                                    gap: 1.5,
                                    alignItems: 'flex-start',
                                    textAlign: 'left'
                                }}
                            >
                                <WarningAmberRoundedIcon sx={{ color: '#d97706', fontSize: '28px', mt: 0.2, flexShrink: 0 }} />
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontWeight: 800, fontSize: '15px', color: '#92400e', mb: 0.5 }}>
                                        Slot Confirmation In Progress / Pending
                                    </Typography>
                                    <Typography sx={{ fontSize: '13px', color: '#78350f', lineHeight: 1.5, mb: 1 }}>
                                        {bookingErrorMessage || bookingFailedAfterPayment ? (
                                            <>System notice: <strong>{bookingErrorMessage || "Booking confirmation pending"}</strong></>
                                        ) : (
                                            <>Finalizing your slot allocation and creating your reservation pass...</>
                                        )}
                                    </Typography>
                                    <Typography sx={{ fontSize: '12.5px', color: '#b45309', fontWeight: 700 }}>
                                        ⚠️ PLEASE DO NOT SUBMIT ANOTHER PAYMENT. Click "Retry Confirmation" below or call our 24/7 team.
                                    </Typography>
                                </Box>
                            </Box>

                            {/* 24/7 Support Banner */}
                            <Box sx={{ p: 2, backgroundColor: '#f8fafc', borderRadius: '14px', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <PhoneOutlinedIcon sx={{ color: '#004777', fontSize: '20px' }} />
                                    <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#1e293b' }}>
                                        Need immediate assistance? +1 800-884-0153
                                    </Typography>
                                </Box>
                                <Typography sx={{ fontSize: '12px', color: '#64748b' }}>
                                    Provide Reference: {capturedPaymentRef || stripeorderid || 'Deposit'}
                                </Typography>
                            </Box>
                        </Box>
                    ) : (
                        <>
                            {/* Non-Refundable Message Callout Banner */}
                            <Box
                                sx={{
                                    backgroundColor: '#fffbeb',
                                    border: '1px solid #fde68a',
                                    borderRadius: '14px',
                                    p: 2,
                                    mb: 2.5,
                                    display: 'flex',
                                    gap: 1.5,
                                    alignItems: 'flex-start'
                                }}
                            >
                                <InfoOutlinedIcon sx={{ color: '#d97706', fontSize: '22px', mt: 0.2, flexShrink: 0 }} />
                                <Box sx={{ flex: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 0.5 }}>
                                        <Typography sx={{ fontWeight: 800, fontSize: '13px', color: '#92400e' }}>
                                            Strict No-Refund Policy Notice
                                        </Typography>
                                        <Chip 
                                            label="Legally Binding" 
                                            size="small" 
                                            sx={{ 
                                                backgroundColor: '#fef3c7', 
                                                color: '#b45309', 
                                                fontWeight: 800, 
                                                fontSize: '10px', 
                                                height: '18px',
                                                border: '1px solid #fcd34d'
                                            }} 
                                        />
                                    </Box>
                                    <Typography sx={{ fontSize: '12.5px', color: '#78350f', lineHeight: 1.5 }}>
                                        All fees paid for Prime Park (deposit of <strong>${totalAmount ?? '25'}</strong>) are strictly final and <strong>non-refundable</strong> upon confirmation.
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Stripe Payment Element */}
                            {!isPaymentReady && (
                                <Box sx={{ py: 5, textAlign: 'center', color: '#64748b' }}>
                                    <CircularProgress size={28} sx={{ color: '#004777', mb: 1.5 }} />
                                    <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>Loading secure payment form...</Typography>
                                </Box>
                            )}
                            <Box sx={{ display: isPaymentReady ? 'block' : 'none' }}>
                                <PaymentElement 
                                    options={{
                                        defaultValues: {
                                            billingDetails: defaultBillingDetails
                                        }
                                    }}
                                    onReady={() => setIsPaymentReady(true)}
                                    onLoadError={(err) => {
                                        console.error('Stripe PaymentElement error:', err);
                                        setErrorMessage(err?.error?.message || err?.message || 'Failed to load Stripe payment element.');
                                    }}
                                />
                            </Box>

                            {/* 3DS / All Sales Final Notice below payment fields */}
                            <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1, color: '#64748b' }}>
                                <VerifiedUserOutlinedIcon sx={{ fontSize: '16px', color: '#16a34a' }} />
                                <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#475569' }}>
                                    All sales are final. Transactions are secured with 3D Secure verification.
                                </Typography>
                            </Box>

                            {/* Mandatory Unchecked "Clickwrap" Checkbox directly above Pay button */}
                            <Box
                                sx={{
                                    mt: 2,
                                    mb: 1.5,
                                    p: 2,
                                    backgroundColor: noRefundAccepted ? '#f0fdf4' : '#f8fafc',
                                    borderRadius: '14px',
                                    border: noRefundAccepted ? '1px solid #86efac' : '1px solid #e2e8f0',
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={noRefundAccepted}
                                            onChange={handleCheckboxToggle}
                                            sx={{
                                                color: '#004777',
                                                '&.Mui-checked': { color: '#004777' },
                                                p: 0.5,
                                                mr: 1,
                                            }}
                                        />
                                    }
                                    label={
                                        <Typography sx={{ fontSize: '12.5px', color: '#1e293b', fontWeight: 500, lineHeight: 1.5 }}>
                                            I have read and agree to the{' '}
                                            <span
                                                role="button"
                                                tabIndex={0}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openPolicy('terms');
                                                }}
                                                style={{ color: '#004777', textDecoration: 'underline', fontWeight: 700, cursor: 'pointer' }}
                                            >
                                                Terms of Service
                                            </span>{' '}
                                            and explicitly authorize this transaction. I understand and accept the{' '}
                                            <span
                                                role="button"
                                                tabIndex={0}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openPolicy('refund');
                                                }}
                                                style={{ color: '#004777', textDecoration: 'underline', fontWeight: 700, cursor: 'pointer' }}
                                            >
                                                Strict No-Refund Policy
                                            </span>
                                            , and agree that all fees paid for Prime Park are final and non-refundable.
                                        </Typography>
                                    }
                                    sx={{ alignItems: 'flex-start', m: 0 }}
                                />
                            </Box>
                        </>
                    )}

                    {/* Error message if any */}
                    {errorMessage && (
                        <Box sx={{ mt: 2, p: 1.5, backgroundColor: '#fef2f2', border: '1px solid #fecaca', borderRadius: '10px' }}>
                            <Typography sx={{ color: '#dc2626', fontSize: '13px', fontWeight: 600 }}>
                                {errorMessage}
                            </Typography>
                        </Box>
                    )}
                </Box>

                {/* Footer Buttons */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column-reverse', sm: 'row' },
                        justifyContent: 'flex-end',
                        alignItems: 'stretch',
                        mt: 2.5,
                        pt: 2,
                        borderTop: '1px solid #f1f5f9',
                        gap: 1.5,
                    }}
                >
                    <button 
                        type="button"
                        onClick={handleSafeCancel} 
                        disabled={isProcessing}
                        style={{ 
                            padding: '12px 28px', 
                            backgroundColor: '#f1f5f9', 
                            color: '#475569', 
                            border: 'none', 
                            borderRadius: '100px', 
                            fontSize: '15px', 
                            fontWeight: '700', 
                            cursor: isProcessing ? 'not-allowed' : 'pointer', 
                            transition: 'all 0.2s',
                            textAlign: 'center'
                        }}
                    >
                        {isPaymentCaptured ? "Close" : "Cancel"}
                    </button>

                    {isPaymentCaptured ? (
                        <button 
                            type="button" 
                            onClick={handleRetryBookingOnly}
                            disabled={isRetryingBooking || isProcessing}
                            style={{ 
                                padding: '12px 35px', 
                                backgroundColor: (isRetryingBooking || isProcessing) ? '#94a3b8' : '#004777', 
                                color: 'white', 
                                border: 'none', 
                                borderRadius: '100px', 
                                fontSize: '15px', 
                                fontWeight: '700', 
                                cursor: (isRetryingBooking || isProcessing) ? 'not-allowed' : 'pointer', 
                                transition: 'all 0.3s', 
                                boxShadow: (isRetryingBooking || isProcessing) ? 'none' : '0 8px 20px rgba(0, 71, 119, 0.25)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                opacity: (isRetryingBooking || isProcessing) ? 0.75 : 1
                            }}
                        >
                            {isRetryingBooking ? (
                                <>
                                    <CircularProgress size={18} sx={{ color: '#fff' }} />
                                    <span>Retrying Confirmation...</span>
                                </>
                            ) : (
                                <>
                                    <RefreshOutlinedIcon sx={{ fontSize: '18px' }} />
                                    <span>Retry Booking Confirmation</span>
                                </>
                            )}
                        </button>
                    ) : (
                        <button 
                            type="submit" 
                            disabled={isPayDisabled}
                            style={{ 
                                padding: '12px 35px', 
                                backgroundColor: isPayDisabled ? '#94a3b8' : '#004777', 
                                color: 'white', 
                                border: 'none', 
                                borderRadius: '100px', 
                                fontSize: '15px', 
                                fontWeight: '700', 
                                cursor: isPayDisabled ? 'not-allowed' : 'pointer', 
                                transition: 'all 0.3s', 
                                boxShadow: isPayDisabled ? 'none' : '0 8px 20px rgba(0, 71, 119, 0.25)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                opacity: isPayDisabled ? 0.75 : 1
                            }}
                        >
                            {isProcessing ? (
                                <>
                                    <CircularProgress size={18} sx={{ color: '#fff' }} />
                                    <span>Processing...</span>
                                </>
                            ) : (
                                <>
                                    <LockOutlinedIcon sx={{ fontSize: '18px' }} />
                                    <span>Pay {totalAmount ? `$${totalAmount}` : 'Now'}</span>
                                </>
                            )}
                        </button>
                    )}
                </Box>
            </form>

            {/* Policy Modal for Terms & Refund Policy */}
            <PolicyModal
                open={policyModalOpen}
                onClose={() => setPolicyModalOpen(false)}
                initialTab={policyModalTab}
                onAccept={() => {
                    setNoRefundAccepted(true);
                    setConsentTimestamp(new Date().toISOString());
                }}
            />
        </>
    );
};

export default PaymentForm;
